import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  text-decoration: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  transition: all 100ms ease-in-out;\n  border: none;\n  box-shadow: none;\n  min-width: 44px;\n  height: 44px;\n  padding: 0 24px;\n  border-radius: 100px;\n  background: ", ";\n  color: #fff;\n  letter-spacing: normal;\n  font-size: 14px;\n  font-weight: 600;\n  position: relative;\n\n  &:hover {\n    background: #70c244;\n  }\n\n  &:disabled {\n    background: ", ";\n    border-color: transparent;\n    color: white;\n    cursor: default;\n    pointer-events: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  ", ";\n\n  ", ";\n  /* Note: Apply type variation styles */\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { Ink } from '../Ink';
import styled, { css } from '../utils/styling/styled-components';
import { BUTTON } from '../utils/testing/TestIDs';
var STYLETYPES = {
  flat: function flat(props) {
    return "\n    background: none;\n    color: ".concat(props.theme.colors.green, ";\n    border-radius: 0;\n\n    &:hover {\n      background: none;\n    }\n\n    ").concat(props.secondary ? "\n      color: ".concat(props.theme.colors.stone, ";\n      border: none;\n    ") : '', "\n\n    ").concat(props.tertiary ? "color: ".concat(props.theme.colors.red, ";") : '', "\n\n    ").concat(props.disabled ? "\n      &, &:disabled {\n        background: none;\n      }\n\n      color: ".concat(props.theme.colors.stoneLight, ";\n    ") : '', "\n  ");
  },
  invalid: function invalid(props) {
    return "\n  background-color: ".concat(props.theme.colors.stoneLight, ";\n  &:hover {\n    background-color: ").concat(props.theme.colors.stoneLight, "\n  ");
  },
  light: function light(props) {
    return "\n    color: ".concat(props.theme.colors.slate, ";\n    background-color: white;\n    box-shadow: ").concat(props.theme.shadows.smDark, ";\n\n    &:hover {\n      background: ").concat(props.theme.colors.ivory, ";\n    }\n\n    ").concat(props.secondary ? "\n      color: white;\n      border: 1px solid #fff;\n      background: #383F41;\n\n      &:hover {\n        background: #41484A\n      }\n    " : '', "\n  ");
  },
  raised: function raised(props) {
    return "\n    box-shadow: ".concat(props.theme.shadows.smMedium, ";\n    border: none;\n  ");
  },
  wire: function wire(props) {
    return "\n    background: none;\n    border: solid 1px ".concat(props.theme.colors.stoneLight, ";\n    &:hover {\n      background: none;\n    }\n  ");
  },
  dark: function dark(props) {
    return "\n    background-color: ".concat(props.theme.colors.slate, ";\n    &:hover {\n      background-color: rgba(25, 25, 25, 0.6);\n    }\n  ");
  },
  mini: function mini(props) {
    return "\n    height: 36px;\n    padding: 0 20px;\n    background: ".concat(props.theme.colors.ivory, ";\n    color: ").concat(props.theme.colors.slate, ";\n\n    &:hover, &:focus {\n      background: ").concat(props.theme.colors.slate, ";\n      color: ").concat(props.theme.colors.white, ";\n    }\n    \n    svg:first-child {\n      margin-right: 10px;\n    }\n\n    svg:nth-last-child(2) {\n      margin-left: 10px;\n    }\n\n    [stroke*=\"#\"] {\n      stroke: currentColor\n      opacity: 1;\n    }\n\n    [fill*=\"#\"] {\n      fill: currentColor\n    }\n  ");
  }
};
var sharedCss = css(_templateObject(), function (props) {
  return props.theme.colors.green;
}, function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.secondary ? "\n        background: #fff;\n        color: ".concat(props.theme.colors.slate, ";\n        border: 0.8pt solid ").concat(props.theme.colors.stoneLight, ";\n\n        &:hover {\n          background: #fff;\n          border-color: ").concat(props.theme.colors.stone, ";\n        }\n      ") : '';
}, function (props) {
  return props.styleType ? STYLETYPES[props.styleType](props) : null;
});
var Container = styled.button(_templateObject2(), sharedCss);
var StyledRouterLink = styled(Link)(_templateObject3(), sharedCss);

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _ref$htmlTag = _ref.htmlTag,
      htmlTag = _ref$htmlTag === void 0 ? 'button' : _ref$htmlTag,
      inkOpacity = _ref.inkOpacity,
      onPress = _ref.onPress,
      ref = _ref.ref,
      secondary = _ref.secondary,
      type = _ref.type,
      buttonType = _ref.buttonType,
      styleType = _ref.styleType,
      testId = _ref.testId,
      props = _objectWithoutProperties(_ref, ["children", "className", "disabled", "htmlTag", "inkOpacity", "onPress", "ref", "secondary", "type", "buttonType", "styleType", "testId"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    as: htmlTag,
    className: className,
    "data-testid": testId ? "".concat(testId, "_").concat(BUTTON) : BUTTON,
    disabled: disabled,
    onClick: onPress,
    ref: ref,
    secondary: secondary,
    styleType: styleType || type,
    type: buttonType || 'button'
  }, props), children, !disabled && /*#__PURE__*/React.createElement(Ink, {
    opacity: inkOpacity,
    secondary: true
  }));
};

var StyledButtonLink = styled(Button)(_templateObject4());

var ButtonLink = function ButtonLink(props) {
  return /*#__PURE__*/React.createElement(StyledButtonLink, _extends({}, props, {
    htmlTag: "a",
    onPress: null
  }));
};

var ButtonRouterLink = function ButtonRouterLink(_ref2) {
  var children = _ref2.children,
      to = _ref2.to,
      props = _objectWithoutProperties(_ref2, ["children", "to"]);

  return /*#__PURE__*/React.createElement(StyledRouterLink, _extends({}, props, {
    to: to
  }), children);
};

export { Button, ButtonLink, ButtonRouterLink };